// React
import { useEffect, useState } from "react";
// MUI
import { Box } from "@mui/material";
// Providers
import { useNavigate, useParams } from "react-router-dom";
import { useSubCompany } from "../../SubCompanies/Provider";
import { useClient } from "../../Clients/Provider";
import { useSite } from "../../Sites/Provider";
import { useEmployees } from "../../employee/Provider";
// Table Custom Render
import AccountCell from "../CompanyTable/AccountCell";
import ActiveCell from "../CompanyTable/ActiveCell";
import SiteCell from "../../employee/EmployeeTable/SiteCell";
// UI
import CustomTable from "../../../ui/CustomTable";
import TabsList from "../../../ui/TabsList";
import ModalBox from "../../../ui/ModalBox";
import PassModal from "../../../ui/PassModal";
import { useCompany } from "../Provider";
import { useAuth } from "../../../services/auth";
import { useSecretKeys } from "../../SecretKeys/provider";
import { useWhiteIps } from "../../WhiteIps/provider";
import Currency from "../RenderCell/Currency";
import Price from "../RenderCell/Price";

function TableInfo({ company = [] }) {
  const navigate = useNavigate();
  let params = useParams();
  const { role } = useAuth();

  const id = params.id;
  const [open, setOpen] = useState(false);
  const [openResetPass, setOpenResetPass] = useState(false);
  const [employeeForDelete] = useState(false);
  const [employeeIdResetPassword, setEmployeeIdResetPassword] = useState(1);
  const [openAddCurrencyPopup, setOpenAddCurrencyPopup] = useState(false);

  const [openUpdateCurrencyPopup, setOpenUpdateCurrencyPopup] = useState(false);
  const [openDeleteCurrencyPopup, setOpenDeleteCurrencyPopup] = useState(false);

  const {
    dispatch,
    deleteCurrency,
  } = useCompany();
  const [selectedCols, setSelectedCols] = useState("");
  const {
    state: {
      list: subCompanies,
      page: pageSubCompany,
      perPage: perPageSubCompanies,
    },
    fetchList: fetchSubCompanies,
  } = useSubCompany();
  const {
    state: { list: clients, page: pageClient, perPage: perPageClient },
    fetchList: fetchClients,
  } = useClient();
  const {
    state: { list: sites, page, perPage },
    fetchList: fetchSites,
  } = useSite();

  const {
    state: { list: employees, page: pageEmployee, perPage: perPageEmployee },
    fetchList: fetchEmployees,
    remove,
  } = useEmployees();
  const {
    state: { list: secretKeys },
    fetchList: fetchSecretKeys,
    edit: editSecretKey,
    deleting: deleteSecretKey,
  } = useSecretKeys();

  const {
    state: { list: WhiteListIps },
    fetchList: fetchWhiteList,
    edit: editWhiteList,
    deleting: deleteWhiteList,
  } = useWhiteIps();
  const tabs = [
    { title: "subCompanies", num: company?.subCompaniesCount },
    { title: "Sites", num: company?.sitesCount },
    { title: "Employees", num: company?.employeesCount },
    { title: "Clients", num: clients?.length },
    { title: "Secret Keys", num: secretKeys?.length },
    { title: "White List Ips", num: WhiteListIps?.length },
    { title: "Currency" },
  ];
  useEffect(() => {
    if (selectedCols === "subCompanies")
      fetchSubCompanies(id, pageSubCompany, perPageSubCompanies);
  }, [id, pageSubCompany, perPageSubCompanies, selectedCols]);
  useEffect(() => {
    if (selectedCols === "Clients") fetchClients(id, pageClient, perPageClient);
  }, [id, pageClient, perPageClient, selectedCols]);
  useEffect(() => {
    if (selectedCols === "Sites") fetchSites(company?.id, page, perPage);
  }, [id, page, perPage, selectedCols, company]);
  useEffect(() => {
    if (selectedCols === "Employees")
      fetchEmployees(id, 0, pageEmployee, perPageEmployee);
  }, [id, page, perPageEmployee, selectedCols]);

  useEffect(() => {
    if (selectedCols === "Secret Keys") {
      fetchSecretKeys(id);
    }
  }, [id, selectedCols]);

  useEffect(() => {
    if (selectedCols === "White List Ips") {
      fetchWhiteList(id);
    }
  }, [id, selectedCols]);
  const handleDetail = (c) => {
    if (selectedCols === "subCompanies")
      navigate(`/subcompanies/SubCompanyDetails/${c}`);
    else if (selectedCols === "Sites") navigate(`/sites/SiteDetail/${c}`);
    else if (selectedCols === "Employees")
      navigate(`/employees/EmployeeDetails/${c}`);
    else if (selectedCols === "Clients")
      navigate(`/clients/ClientDetails/${c}`);
  };

  const handleDelete = (id) => {
    try {
      remove(employeeForDelete);
    } catch (e) {
      console.log("error", e);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  // Modal Reset Password
  const handleCloseResetPass = () => {
    setOpenResetPass(false);
  };
  const handleOpenResetPass = (user) => {
    setOpenResetPass(true);
    setEmployeeIdResetPassword(user.id);
  };

  const getCols = (name) => {
    switch (name) {
      case "subCompanies":
        return [
          {
            label: "Sub Company Name",
            name: "subCompanyName",
            textLeft: true,
            headTextLeft: true,
          },
          { label: "Sites Number", name: "siteCount" },
          {
            label: "Sub Company Status",
            name: "isActive",
            customRender: ActiveCell,
          },
        ];
      case "Employees":
        return [
          {
            label: "Employee Code",
            name: "employeeCode",
            headTextLeft: true,
            textLeft: true,
          },
          {
            label: "Employee Full Name",
            name: "fullName",
            headTextLeft: true,
            textLeft: true,
          },
          {
            label: "Current Site Name",
            name: "currentSite",
            customRender: SiteCell,
          },
          {
            label: "User account",
            name: "userId",
            customRender: AccountCell,
          },
        ];
      case "Sites":
        return [
          {
            label: "Site Id",
            name: "id",
            headTextLeft: true,
            textLeft: true,
          },
          {
            label: "Site Name",
            name: "siteName",
          },
          { label: "Site Country", name: "country" },
          {
            label: "Employees Number",
            name: "employeeNumber",
          },
          { label: "Site Status", name: "isActive", customRender: ActiveCell },
        ];
      case "Clients":
        return [
          {
            label: "Client Name",
            name: "clientName",
            headTextLeft: true,
            textLeft: true,
          },
          { label: "Sites Number", name: "siteCount" },
          { label: "Client Status", name: "isActive", customRender: ActiveCell },
        ];
      case "Secret Keys":
        return [
          {
            label: "Secret Key",
            name: "secretKey",
          },
          {
            label: "Description",
            name: "description",
            editable: true,
          },
          {
            label: "Status",
            name: "isActive",
            customRender: ActiveCell,
            editable: true,
          },
        ];
      case "White List Ips":
        return [
          {
            label: "IP",
            name: "ip",
            editable: true,
          },
          {
            label: "Description",
            name: "description",
            editable: true,
          },
          {
            label: "Status",
            name: "isActive",
            customRender: ActiveCell,
            editable: true,
          },
        ];
      case "Currency":
        return [
          {
            label: "Currency",
            customRender: Currency,
          },
          { label: "Value", customRender: Price },
        ];
      default:
        return;
    }
  };

  const getData = (name) => {
    switch (name) {
      case "subCompanies":
        return subCompanies;
      case "Sites":
        return sites;
      case "Employees":
        return employees;
      case "Clients":
        return clients;
      case "Secret Keys":
        return secretKeys;
      case "White List Ips":
        return WhiteListIps;
      case "Currency":
        if (company?.currency) {
          return [
            {
              currency: ["USD", "Euro", "Tolerance Of Exchange"],
              value: company?.currency
                ? [
                    company?.currency?.usdPrice,
                    company?.currency?.euroPrice,
                    company?.currency?.toleranceOfExchange,
                  ]
                : [],
            },
          ];
        } else return [];
      default:
        return;
    }
  };
  const getFilters = (name) => {
    switch (name) {
      case "subCompanies":
        return {
          add: () => navigate(`/SubCompanies/add/${id}`),
        };
      case "Sites":
        return { add: () => navigate(`/sites/add/${id}`) };
      case "Employees":
        return {
          add: () => {
            navigate(`/employees/add/${id}`);
          },
          search: (e) => {
            console.log(e);
          },
        };
      case "Clients":
        return {
          add: () => {
            navigate(`/clients/add/${id}`);
          },
        };
      case "Secret Keys":
        return {
          add: () => {
            navigate(`AddSecretKey`);
          },
          search: (e) => {
            console.log(e);
          },
        };
      case "White List Ips":
        return {
          add: () => {
            navigate(`AddWhiteIp`);
          },
          search: (e) => {
            console.log(e);
          },
        };
      case "Currency":
        if (!company?.currency) {
          return {
            add: () => {
              setOpenAddCurrencyPopup(!openAddCurrencyPopup);
            },
          };
        }
        break;
      default:
        return;
    }
  };
  const handleEditSecretKey = async (row, sid) => {
    delete row[0].id;
    delete row[0].company;
    delete row[0].companyId;
    delete row[0].secretKey;
    try {
      await editSecretKey(sid, row[0]);
      fetchSecretKeys(id);
    } catch (error) {
      console.log(error, "error");
    }
  };
  const handleDeleteSecretKey = async (rowID) => {
    try {
      await deleteSecretKey(rowID);
      fetchSecretKeys(id);
    } catch (error) {
      console.log(error);
    }
  };
  const handleEditWhiteIp = async (row, wid) => {
    delete row[0].id;
    delete row[0].company;
    delete row[0].secretKey;
    try {
      await editWhiteList(wid, row[0]);
      fetchWhiteList(id);
    } catch (error) {
      console.log(error, "error");
    }
  };
  const handleDeleteWhiteIp = async (rowID) => {
    try {
      await deleteWhiteList(rowID);
      fetchWhiteList(id);
    } catch (error) {
      console.log(error);
    }
  };
  const DeleteCurrency = () => {
    deleteCurrency(company?.id);
  };
  const getActions = (name) => {
    switch (name) {
      case "Employees":
        return {
          emoloyee: true,
          edit: (id) => navigate("/employees/edit/" + id),
          // delete: (e) => {
          //   setOpen(true);
          //   setEmployeeForDelete(e);
          // },
        };
      case "Secret Keys":
        return {
          inTableEdit: true,
          edit: handleEditSecretKey,
          delete: handleDeleteSecretKey,
        };
      case "White List Ips":
        return {
          inTableEdit: true,
          edit: handleEditWhiteIp,
          delete: handleDeleteWhiteIp,
        };
      case "Currency":
        return {
          edit: (id) => {
            setOpenUpdateCurrencyPopup(!openUpdateCurrencyPopup);
          },
          delete: DeleteCurrency,
        };
      default:
        return;
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <TabsList
        tabs={tabs}
        selectedCols={selectedCols}
        setSelectedCols={setSelectedCols}
        dispatch={dispatch}
      ></TabsList>
      <CustomTable
        empty={getData(selectedCols)?.length === 0}
        cols={getCols(selectedCols)}
        data={getData(selectedCols)}
        filters={
          (role === "Admin" || role === "Company") && getFilters(selectedCols)
        }
        actions={getActions(selectedCols)}
        moreOptions={
          selectedCols !== "Secret Keys" &&
          selectedCols !== "Currency" &&
          selectedCols !== "White List Ips" && {
            detail: handleDetail,
          }
        }
        renderParams={{
          openModal: handleOpenResetPass,
        }}
        showButton={true}
        isPagination={false}
      ></CustomTable>

      {selectedCols === "Employees" && (
        <>
          <ModalBox
            open={open}
            operation="delete"
            handleClose={handleClose}
            handleOperation={handleDelete}
            text="The delete operation has been completed successfully.."
            name="employee"
          />
          <PassModal
            open={openResetPass}
            handleClose={handleCloseResetPass}
            employeeId={employeeIdResetPassword}
          />
        </>
      )}
      <ModalBox
        open={openDeleteCurrencyPopup}
        operation="delete"
        handleClose={() => setOpenDeleteCurrencyPopup(!openDeleteCurrencyPopup)}
        handleOperation={DeleteCurrency}
        text="The delete operation has been completed successfully.."
        name="currency"
      />
      <ModalBox
        open={openAddCurrencyPopup}
        operation="AddCurrency"
        handleClose={() => {
          setOpenAddCurrencyPopup(!openAddCurrencyPopup);
        }}
      />
      <ModalBox
        open={openUpdateCurrencyPopup}
        operation="UpdateCurrency"
        handleClose={() => {
          setOpenUpdateCurrencyPopup(!openUpdateCurrencyPopup);
        }}
        currency={company.currency}
      />
    </Box>
  );
}

export default TableInfo;
